


























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { removeTrailingZeros } from '@/utils/moneyFormarter';

type TriggerPosition = 'header' | 'footer';

@Component({
  components: {
    Typography
  }
})
export default class CoinNetworkCharges extends Vue {
  @Prop() subscription!: any;

  observer: IntersectionObserver | null = null;
  triggerVisibility: Record<TriggerPosition, boolean> = {
    header: false,
    footer: false
  };

  get tPrefix() {
    return 'modals.billing.acceptance.charges';
  }

  getCoinsFee(fee: string) {
    return `${removeTrailingZeros(fee)} Coins`;
  }

  handleTriggerObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;
          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector('.coin-network-charges__body'),
        threshold: 0
      }
    );

    const targets = document.querySelectorAll<HTMLElement>(
      '.coin-network-charges__body-trigger'
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  mounted() {
    this.handleTriggerObserver();
  }
}
